import React from 'react';
import Translation from '../translation/translation';

function SelectFSLightBoxHeader({ data, error }) {
    return (
        <div className="select-fs-light-box__header select-fs-light-box-header">
            {error && error.invalid && <>
                <Translation
                    translationKey="error-note"
                    className="select-fs-light-box-header__headline"
                />
            </>}
            {error && !error.invalid && <>
                <Translation
                    translationKey="select-fs-light-box-header"
                    className="select-fs-light-box-header__headline"
                    placeholder={{ 'FS_DISPLAY_NAME': (data?.title || '') }}
                />
            </>}
        </div>
    );
}

export { SelectFSLightBoxHeader };
